import React, { useEffect, useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import { Typography, FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";

export default function WaterMgmtToolsPopup(props) {
	const {
		fieldDetails,

		parentPreSMChange,
		parentPreFLChange,
		parentPreETChange,
		parentPreNOChange,

		parentPostSMChange,
		parentPostFLChange,
		parentPostETChange,
	} = props;

	// Pre state
	const [preSoilMoisture, setPreSoilMoisture] = useState(fieldDetails.prewater.preyearsoilmoisture);
	const [preFlow, setPreFlow] = useState(fieldDetails.prewater.preyearflow);
	const [preET, setPreET] = useState(fieldDetails.prewater.preyearet);
	const [preNone, setPreNone] = useState(fieldDetails.prewater.preyearno);

	// Post state
	const [postSoilMoisture, setPostSoilMoisture] = useState(fieldDetails.postwater.postyearsoilmoisture);
	const [postFlow, setPostFlow] = useState(fieldDetails.postwater.postyearflow);
	const [postET, setPostET] = useState(fieldDetails.postwater.postyearet);

	// Handlers for Pre
	const handleSoilMoistureChange = (event) => {
		if (!preNone) {
			setPreSoilMoisture(event.target.checked);
			parentPreSMChange(event.target.checked);
		}
	};
	const handleFlowChange = (event) => {
		if (!preNone) {
			setPreFlow(event.target.checked);
			parentPreFLChange(event.target.checked);
		}
	};
	const handleEtChange = (event) => {
		if (!preNone) {
			setPreET(event.target.checked);
			parentPreETChange(event.target.checked);
		}
	};
	const handleNoneChange = (event) => {
		setPreNone(event.target.checked);
		if (event.target.checked) {
			setPreET(false);
			setPreFlow(false);
			setPreSoilMoisture(false);
		}
		parentPreNOChange(event.target.checked);
	};

	// Handlers for Post
	const handlePostSoilMoistureChange = (event) => {
		setPostSoilMoisture(event.target.checked);
		parentPostSMChange(event.target.checked);
	};
	const handlePostFlowChange = (event) => {
		setPostFlow(event.target.checked);
		parentPostFLChange(event.target.checked);
	};
	const handlePostEtChange = (event) => {
		setPostET(event.target.checked);
		parentPostETChange(event.target.checked);
	};

	useEffect(() => {
		if (preNone) {
			setPreET(false);
			setPreFlow(false);
			setPreSoilMoisture(false);
		}
	}, [preNone]);

	const waterMgmtPeriods = {
		Pre: {
			controls: [
				{
					label: "Soil Moisture Equipment",
					value: preSoilMoisture,
					changeHandler: handleSoilMoistureChange,
				},
				{
					label: "Flow Meter",
					value: preFlow,
					changeHandler: handleFlowChange,
				},
				{
					label: "Use of ET Information",
					value: preET,
					changeHandler: handleEtChange,
				},
				{
					label: "None of the above",
					value: preNone,
					changeHandler: handleNoneChange,
				},
			],
			label: "Select the water management tools currently in use on this field (select all that apply).",
		},
		Post: {
			controls: [
				{
					label: "Soil Moisture Equipment",
					value: postSoilMoisture,
					changeHandler: handlePostSoilMoistureChange,
				},
				{
					label: "Flow Meter",
					value: postFlow,
					changeHandler: handlePostFlowChange,
				},
				{
					label: "Use of ET Information",
					value: postET,
					changeHandler: handlePostEtChange,
				},
			],
			label:
				"Select the water management tools that will be used on this field as part of your proposed project (select all that apply).",
		},
	};

	return (
		<div>
			<div
				id="waterMgmtDataEntryArea"
				style={{ display: "flex", flexDirection: "row", width: "100%", flexWrap: "wrap", gap: 16 }}
			>
				{Object.entries(waterMgmtPeriods).map(([periodKey, period], idx) => {
					const periodTitle = periodKey + "-Project";
					return (
						<React.Fragment key={periodKey}>
							<div
								id={periodTitle}
								style={{ width: 425, display: "flex", flexDirection: "column", justifyContent: "flex-start" }}
							>
								<Typography style={{ fontSize: "1.5rem", fontWeight: "400" }}>{periodTitle}</Typography>
								<div style={{ marginTop: "10px" }}>
									<InputLabel variant="standard" color="primary">
										{period.label}
									</InputLabel>
								</div>
								<div style={{ marginTop: "10px" }}>
									<FormGroup>
										{period.controls.map((control, index) => (
											<FormControlLabel
												control={
													<Checkbox
														checked={control.value}
														onChange={control.changeHandler}
														name={control.label}
														disabled={periodKey === "Pre" && preNone && index < period.controls.length - 1}
													/>
												}
												label={control.label}
											/>
										))}
									</FormGroup>
								</div>
							</div>
							{idx === 0 && <div className="vertical-divider" />}
						</React.Fragment>
					);
				})}
			</div>
			<style>{`
				.vertical-divider {
					height: auto;
					width: 2px;
					background: #e0e0e0;
					margin: 0 12px;
					align-self: stretch;
				}
				@media (max-width: 1050px) {
					#waterMgmtDataEntryArea {
						flex-direction: column !important;
					}
					.vertical-divider {
						display: none;
					}
				}
			`}</style>
		</div>
	);
}
